// App-level wiring for the extracted `slickpay-js` package: this is the only
// place that knows about our env vars. Everything else imports this instance.
//
// IMPORTANT: the bearer key is bundled into the frontend JS and is therefore
// visible to anyone opening devtools. That's acceptable for the sandbox key
// used here, but a production key should not be called directly from the
// browser — run slickpay-js behind a backend endpoint instead so the key
// never leaves the server.
import { SlickPay, PendingPayment } from "slickpay-js";

const slickpay = new SlickPay({
  publicKey: process.env.VUE_APP_SLICKPAY_PUBLIC_KEY,
  account: process.env.VUE_APP_SLICKPAY_ACCOUNT,
  // Sandbox by default; point VUE_APP_SLICKPAY_BASEURL at
  // https://prodapi.slick-pay.com/api/v2/ once validated.
  baseUrl: process.env.VUE_APP_SLICKPAY_BASEURL || undefined,
});

// Holds the in-flight card request across the SATIM redirect, which leaves the
// SPA entirely.
export const pendingCardRequest = new PendingPayment("pendingCardRequest");

export default slickpay;
